<template>
    <div :class="['single-learningpath-certificate', { 'not-subscribed': !isSubscribed }, { 'no-access': userHasNoAccess } ]">
        <div :class="['single-learningpath-certificate__image-container', { 'not-complete': !isLearningPathCompleted } ]">
            <img class="single-learningpath-certificate__image" :src="require('@/assets/images/learningpaths/learningpath_certificate.png')" alt="">
            <span class="icon-crown-outlined single-learningpath-certificate__image-center-logo"></span>
        </div>
        <div :class="['single-learningpath-certificate__certificate-container', { 'not-complete': !isLearningPathCompleted } ]">
            <div class="single-learningpath-certificate__info-box">
                <div class="single-learningpath-certificate__title">
                    <span v-html="$t('LearningPath.certificate_title')"></span>
                </div>
                <div class="single-learningpath-certificate__description">
                    <p v-html="$t('LearningPath.certificate_description')"></p>
                </div>
                <div class="single-learningpath-certificate__button-container">
                    <TotemButton
                        :disabled="!isLearningPathCompleted"
                        size="medium"
                        color="primary"
                        class="single-learningpath-certificate__button"
                        @click="createCertificate"
                        :label="$t('CourseTest.load_certificate_learningpath')"
                    />
                </div>
            </div>
        </div>
        <SingleLearningPathItemPath
            :learningPathId="learningPathId"
            :isLoggedIn="isLoggedIn"
            :isParagraphInBetweenCourses="extendPathGraph"
            :length="amountOfCourses"
            :isLearningPathCertificate="true"
            :isCourseCompleted="isLearningPathCompleted"
        />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex'
    import SingleLearningPathItemPath from 'components/learningpathpage/learningpath-item/SingleLearningPathItemPath'
    import CourseImagesHelper from 'components/shared/global-courses-items/helper/course-images-helper'

    export default {
        components: {
            SingleLearningPathItemPath,
        },
        mixins: [ CourseImagesHelper ],
        props: {
            extendPathGraph: Boolean,
            amountOfCourses: Number,
            isSubscribed: Boolean,
            isLearningPathCompleted: Boolean,
            learningPathId: Number
        },
        computed: {
            ...mapGetters({
                isLoggedIn: 'isLoggedIn',
                getCertificateForLearningPath: 'CompletedCourses/getCertificateForLearningPath',
                certificates: 'CompletedCourses/certificates'
            }),
            userHasNoAccess () {
                return !this.isLoggedIn
            },
            learningPathCompleted () {
                return this.getCertificateForLearningPath(this.learningPathId)
            },
            learningPathCerticiateLogo () {
                return require('assets/images/learningpaths/learningpath_certificate_logo.svg')
            },
        },
        methods: {
            createCertificate () {
                if (this.learningPathCompleted) {
                    this.$store.dispatch('Certificates/createCertificate', this.getLearningPathCertificate(this.learningPathId))
                }
            },
            getLearningPathCertificate (learningPathId) {
                const learningPath = this.certificates.learningPaths.find(learningPath => learningPath.id === learningPathId)
                return learningPath?.certificate
            }
        },
        watch: {
            isLearningPathCompleted: {
                async handler (isLearningPathCompleted) {
                    if (isLearningPathCompleted) {
                        if (!this.getLearningPathCertificate(this.learningPathId)) {
                            await this.$store.dispatch('LearningPaths/createLearningPathCertificate', this.learningPathId)
                            await this.$store.dispatch('CompletedCourses/loadCertificates')
                        }
                    }
                },
                immediate: true
            }
        },
    }
</script>

<style lang="scss" scoped>
    .single-learningpath-certificate {
        position: relative;
        display: flex;
        background: $white;
        border: 1px solid $quill_gray;
        margin: 0 0 20px 0;
        height: 100%;
        min-height: 87px;

        [class*="mobile"] & {
            position: relative;
            background: $white;
            display: flex;
            border-radius: 4px;
            flex-direction: column;
            height: 100%;
            margin: 0 15px;
        }

        [class*="desktop"] & {
            height: 230px;
            margin: 0 0 35px 125px;
        }

        &__image-container {
            position: relative;
            flex-shrink: 0;
            overflow: hidden;
            width: 340px;

            &.not-complete {
                opacity: 0.5;
                pointer-events: none
            }

            [class*="mobile"] & {
                width: 100%;
                height: 100px;
            }
        }

        &__image {
            align-self: flex-start;
            object-fit: cover;
            height: 100%;
            width: 340px;

            [class*="mobile"] & {
                align-self: flex-start;
                object-fit: cover;
                object-position: left;
                width: 100%;
                height: 100px;
            }
        }

        &__info-box {
            padding: 16px 30px 20px 30px;
            display: flex;
            flex-direction: column;
            width: 100%;

            [class*="mobile"] & {
                padding: 15px 15px 5px;
            }
        }

        &__button-container {
            margin: 20px 0;

            [class*="mobile"] & {
                margin: 0 auto;
                padding: 20px;
            }
        }

        &__certificate-container {
            display: flex;
            flex-direction: column;
            width: 100%;

            &.not-complete {
                opacity: 0.5;
                pointer-events: none
            }
        }

        &__title {
            font-family: Nunito-Medium, sans-serif;
            font-size: 1.6rem;
            padding: 0 10px 10px 0;
            display: block;

            [class*="mobile_sm"] & {
                font-size: 1.25rem;
            }

            [class*="desktop"] & {
                font-size: 1.8rem;
            }
        }

        &__description {
            font-family: Nunito-Regular, sans-serif;
            font-size: 1.5rem;
            margin: 0 0 10px 0;

            [class*="mobile"] & {
                margin: 0 0 5px 0;
            }
        }

        &.no-access {
            border-color: $gallery;
            background: $alabaster;
            color: $emperor;
        }

        &.not-subscribed {
            opacity: 0.5;
            pointer-events: none
        }

        &__image-center-logo {
            position: absolute;
            top: 50%;
            left: 50%;
            font-size: 8rem;
            color: $white;
            transform: translate(-50%, -50%);

            [class*="mobile"] & {
                width: 80px;
                height: 70px;
            }
        }
    }
</style>
